export default "__VITE_ASSET__Cvs_JWyE__"